import { VisuallyHidden } from 'react-aria';
import { federalCssStylesEnabled as isFederalInstance } from '@gonfalon/constants/constants';
import { Message } from '@gonfalon/messages/Message';
import { Link } from '@launchpad-ui/components';
import { Icon } from '@launchpad-ui/icons';
import cx from 'clsx';

import { trackCreateSupportTicket } from './trackCreateSupportTicket';

import styles from './CreateSupportTicketLink.module.css';

type CreateSupportTicketLinkProps = {
  onClick?: () => void;
  identifierForAnalyticsTracking?: string;
  hideIcon?: boolean;
  text?: string;
};

export const CreateSupportTicketLink = ({
  onClick,
  identifierForAnalyticsTracking = '',
  hideIcon = false,
  text = 'create a support ticket',
}: CreateSupportTicketLinkProps) => {
  const handleClick = () => {
    onClick?.();
    trackCreateSupportTicket(identifierForAnalyticsTracking);
  };

  const SUPPORT_TICKET_URL = isFederalInstance()
    ? 'https://support.launchdarkly.us'
    : 'https://support.launchdarkly.com';

  return (
    <Link
      href={`${SUPPORT_TICKET_URL}/hc/en-us/requests/new`}
      rel="noopener noreferrer"
      target="_blank"
      onPress={handleClick}
      className={styles.link}
    >
      {text}
      <VisuallyHidden elementType="span">
        <Message id="ui.newTabLink.opensInNewTab" />
      </VisuallyHidden>
      {!hideIcon && (
        <Icon name="link-external" data-test-id="new-tab-link-icon" className={cx('Icon', styles.icon)} size="small" />
      )}
    </Link>
  );
};
